var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    { attrs: { "rnd-id": "lang", hoverable: "", "aria-role": "list" } },
    [
      _c("img", {
        attrs: {
          slot: "trigger",
          src: require("@/assets/images/flags/" + _vm.language.flag + ".png"),
          alt: _vm.$i18n.locale
        },
        slot: "trigger"
      }),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          attrs: { "aria-role": "listitem" },
          on: {
            click: function($event) {
              return _vm.handleSetLanguage("de")
            }
          }
        },
        [
          _c("div", { staticClass: "media", attrs: { "rnd-id": "lang-de" } }, [
            _c("img", {
              staticClass: "media-left",
              attrs: { src: require("@/assets/images/flags/de.png"), alt: "de" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "media-content" }, [
              _c("p", [_vm._v("Deutsch")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          attrs: { "aria-role": "listitem" },
          on: {
            click: function($event) {
              return _vm.handleSetLanguage("en")
            }
          }
        },
        [
          _c("div", { staticClass: "media", attrs: { "rnd-id": "lang-en" } }, [
            _c("img", {
              staticClass: "media-left",
              attrs: { src: require("@/assets/images/flags/en.png"), alt: "en" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "media-content" }, [
              _c("p", [_vm._v("English")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          attrs: { "aria-role": "listitem" },
          on: {
            click: function($event) {
              return _vm.handleSetLanguage("fr")
            }
          }
        },
        [
          _c("div", { staticClass: "media", attrs: { "rnd-id": "lang-fr" } }, [
            _c("img", {
              staticClass: "media-left",
              attrs: { src: require("@/assets/images/flags/fr.png"), alt: "fr" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "media-content" }, [
              _c("p", [_vm._v("Français")])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-dropdown-item",
        {
          attrs: { "aria-role": "listitem" },
          on: {
            click: function($event) {
              return _vm.handleSetLanguage("it")
            }
          }
        },
        [
          _c("div", { staticClass: "media", attrs: { "rnd-id": "lang-it" } }, [
            _c("img", {
              staticClass: "media-left",
              attrs: { src: require("@/assets/images/flags/it.png"), alt: "it" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "media-content" }, [
              _c("p", [_vm._v("Italiano")])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4e3daac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4e3daac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/land-select/LangSelect.vue
// module id = null
// module chunks = 